import { render } from "./CostosList.vue?vue&type=template&id=7db18cfe&scoped=true"
import script from "./CostosList.vue?vue&type=script&lang=js"
export * from "./CostosList.vue?vue&type=script&lang=js"

import "./CostosList.vue?vue&type=style&index=0&id=7db18cfe&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db18cfe"]])

export default __exports__